import api from "@helpers/api";
import { t } from "@i18n";

/**
 * @param {number|string} communityId
 * @param {{ category: string, file_info: { content_type: string, extension: string, filename: string } }} body
 * @returns {Promise<{ upload_url: string, final_url: string }>}
 */
export async function requestPresignedUpload(communityId, body) {
  const res = await api.post(`community/${communityId}/assets`, body);
  const data = res?.data;
  if (data?.upload_url && data?.final_url) {
    return data;
  }
  const fallback = t("content:upload.presignError");
  const msg =
    res?.response?.data?.message ||
    res?.message ||
    fallback;
  throw new Error(typeof msg === "string" ? msg : fallback);
}
